import { FileRejection } from 'react-dropzone';
import { fData } from '../../../utils/formatNumber';
import { fileData } from '../utils';

// ----------------------------------------------------------------------

type Props = {
  fileRejections: readonly FileRejection[];
};

export default function RejectionFiles({ fileRejections }: Props) {
  if (!fileRejections.length) {
    return null;
  }

  return (
    <div className="mt-3 rounded-lg border border-destructive/30 bg-destructive/10 px-4 py-2">
      {fileRejections.map(({ file, errors }) => {
        const { path, size } = fileData(file);

        return (
          <div key={path} className="my-1">
            <p className="truncate text-sm font-medium">
              {path} - {size ? fData(size) : ''}
            </p>

            {errors.map((error) => (
              <span key={error.code} className="text-xs text-destructive">
                - {error.message}
              </span>
            ))}
          </div>
        );
      })}
    </div>
  );
}
